import React, { FC } from "react";
import './JBadgeList.scss';
import {useJCommonContext} from "../JCommonProvider";

export interface JBadgeListItem {
    imageRef?: string;
    value: string | number;
    title?: string;
    text?: string;
};

export interface JBadgeListProps {
    items: JBadgeListItem[]
}

export const JBadgeList: FC<JBadgeListProps> = ({ items }) => {
    const {getImageURL} = useJCommonContext();
    return (
        <div className="jbadge-list">
            {
                items.map((item, i) => (
                    <div key={i} className="jbadge-list-item">
                        {
                            item.imageRef && (
                                <img aria-hidden={true} src={getImageURL(item.imageRef)} />
                            )
                        }
                        <b>{item.value}</b>
                    </div>
                ))
            }
        </div>
    )
}
